// ** Next Imports
import Link from "next/link";
import Image from "next/image";

// ** File Imports
import Layout, { SEOHead } from "../../layouts/default";

// ** FA Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

// ** Image Imports
import detail1Img from "../../../public/images/detail-1.jpg";
import detail2Img from "../../../public/images/detail-2.jpg";

const ResidentialServices = () => (
  <Layout>
    <SEOHead title="Unlimited Internet Services for Home. No Credit Check.">
      <meta
        name="description"
        content="EIN offers easy and fast internet services for your home. No credit checks. Fast and Hassle Free Internet Only. Unlimited residential internet plans near you."
      ></meta>
      <meta
        name="keywords"
        content="internet services for home, no credit check internet, unlimited internet, internet no credit check near me"
      />
    </SEOHead>

    <section className="bg-silver1 pad-top-40 pad-bot-40">
      <div className="container">
        <div className="sec-head">
          <h1 className="no-margin">
            <b> Residential Services </b>
          </h1>
        </div>
      </div>
    </section>
    <section className="pad-top-60 pad-bot-60">
      <div className="container">
        <div className="row equal-col">
          <div className="col-md-6 col-lg-6 col-sm-12 col-12 order-lg-2 order-md-2 order-sm-1 order-1">
            <div className="detail-image">
              <Image
                src={detail1Img}
                alt="High speed internet"
                className="img-fluid"
                placeholder="blur"
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-12  order-lg-1 order-md-1 order-sm-2 order-2">
            <div className="detail-text">
              <h5 className="col-grey1">EIN RESIDENTIAL SERVICE</h5>
              <h3 className="col-black">High Speed Internet</h3>
              <p className="col-grey1">
                EIN Residential service is perfect for any home. We utilize
                existing service lines already in place your residence, and each
                of our new customers is professionally installed by a technician
                who will set up your modem and your home WIFI. They&apos;ll even
                help you understand how to connect all of your devices, such as
                your laptop or gaming system, to your new network!
              </p>
              <p className="col-grey1">
                Our plans are all UNLIMITED, which means you never have to worry
                about going over a data cap or having your connection throttled.
                No contracts, no credit check, and you can change plans at any
                time without penalty!
              </p>
              <Link href="/check-availability" className="custom-btn2">
                Check Availability <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>
        </div>
        <div className="row equal-col m-t-50">
          <div className="col-md-6 col-lg-6 col-sm-12 col-12 order-lg-1 order-md-1 order-sm-1 order-1">
            <div className="detail-image">
              <Image
                src={detail2Img}
                alt="Request Information"
                className="img-fluid"
                placeholder="blur"
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-12  order-lg-2 order-md-2 order-sm-2 order-2">
            <div className="detail-text detail-text2">
              <h5 className="col-grey1">REQUEST</h5>
              <h3 className="col-black">Request Information</h3>
              <p className="col-grey1">
                Send us a request for more information and we will send you back
                all the information you need to help make a decision.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default ResidentialServices;
